/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { request } from '@mairistem/tools';

import { getHubeeStatus } from '@/routes';
import type { HubeeStatus } from '@/types';
import { useHubeeStore } from '@/zustand';

/**
 * Charge l'état de la liaison HubEE (abonnement + liaison active) de
 * l'entité dans le store, comme dans RCO.
 */
const useFetchHubeeStatus = () => {
  const setHubeeStatus = useHubeeStore((state) => state.setHubeeStatus);
  const setLoading = useHubeeStore((state) => state.setLoading);

  const fetchHubeeStatus = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await request.get(getHubeeStatus());
      setHubeeStatus(response as HubeeStatus);
    } catch {
      // Statut illisible : la liste est traitée comme non activée.
      setHubeeStatus({ serialized: false, liaisonActive: false });
    } finally {
      setLoading(false);
    }
  }, [setHubeeStatus, setLoading]);

  return { fetchHubeeStatus };
};

export default useFetchHubeeStatus;
